import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useSupplier } from "@/context/SupplierContext";
import POLineItemTable from "@/components/POLineItemTable";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function SupplierPOs({ requireAction = false }) {
  const [pos, setPos] = useState([]);
  const [q, setQ] = useState("");
  const { selected, isAll, activeBuyer, loaded } = useSupplier();

  useEffect(() => {
    if (!loaded) return;
    api.get(`/pos?buyer_org=${selected}`).then((r) => setPos(r.data.pos)).catch(() => {});
  }, [selected, loaded]);

  const today = new Date().toISOString().slice(0, 10);
  let filtered = pos;
  if (requireAction) {
    filtered = pos.filter((p) =>
      ["po_created", "po_sent", "ack_pending"].includes(p.status) ||
      (!["delivered", "closed", "cancelled"].includes(p.status) && p.expected_delivery_date < today));
  }
  if (q.trim()) {
    const ql = q.toLowerCase();
    filtered = filtered.filter((p) => p.po_number.toLowerCase().includes(ql) || p.item.toLowerCase().includes(ql)
      || (p.line_items || []).some((li) => (li.material_code || "").toLowerCase().includes(ql) || (li.description || "").toLowerCase().includes(ql)));
  }

  return (
    <div data-testid={requireAction ? "supplier-updates-page" : "supplier-pos-page"} className="space-y-4">
      <div>
        <h1 className="font-heading text-2xl font-semibold tracking-tight">{requireAction ? "Updates Required" : "My Purchase Orders"}</h1>
        <p className="text-sm text-muted-foreground">
          {filtered.length} POs · <span className="font-medium text-slate-700" data-testid="pos-context-label">{isAll ? "All Buyer Organizations" : activeBuyer?.name}</span>
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <div className="relative max-w-md flex-1">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input data-testid="supplier-po-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search PO number, material code or description…" className="bg-white pl-9" />
        </div>
      </div>
      <POLineItemTable pos={filtered} showValue={false} showBuyer={isAll} linkBase="/seller/pos" testPrefix="supplier-pos-table" rowTestPrefix="supplier-po" />
    </div>
  );
}
